// test1928
(1928 && 0);
